import axios from 'axios'

export default {
  async acceptPrivacyPolicy (token: string): Promise<any> {
    return axios.post(`${process.env.VUE_APP_API_URL}/privacy-token`, { token })
  }
}
